module.exports = [
    {
      "index": 0,
      "guid": "20ab263d-dfdd-429b-a7a3-2e7011f1a30f",
      "isActive": false,
      "balance": "$3,516.28",
      "picture": "http://placehold.it/32x32",
      "age": 32,
      "eyeColor": "brown",
      "name": "Lola Baker",
      "gender": "female",
      "company": "RUGSTARS",
      "email": "lolabaker@rugstars.com",
      "phone": "+1 (824) 495-2194"
    },
    {
      "index": 1,
      "guid": "922592ab-74d3-4c14-8477-89e5c370b33b",
      "isActive": true,
      "balance": "$2,190.62",
      "picture": "http://placehold.it/32x32",
      "age": 23,
      "eyeColor": "blue",
      "name": "Cardenas Buck",
      "gender": "male",
      "company": "MARKETOID",
      "email": "cardenasbuck@marketoid.com",
      "phone": "+1 (947) 498-3756"
    },
    {
      "index": 2,
      "guid": "bed2a1be-d831-4806-a444-039bccccd01f",
      "isActive": false,
      "balance": "$1,558.56",
      "picture": "http://placehold.it/32x32",
      "age": 32,
      "eyeColor": "blue",
      "name": "Viola Lester",
      "gender": "female",
      "company": "ENOMEN",
      "email": "violalester@enomen.com",
      "phone": "+1 (819) 568-2989"
    },
    {
      "index": 3,
      "guid": "41368236-96f9-4254-b64b-f769eb7273fe",
      "isActive": true,
      "balance": "$3,160.72",
      "picture": "http://placehold.it/32x32",
      "age": 27,
      "eyeColor": "green",
      "name": "Fowler Ballard",
      "gender": "male",
      "company": "NIXELT",
      "email": "fowlerballard@nixelt.com",
      "phone": "+1 (866) 549-2361"
    },
    {
      "index": 4,
      "guid": "5e0ed142-f25c-41ce-988a-f0efe0ee1290",
      "isActive": true,
      "balance": "$3,548.53",
      "picture": "http://placehold.it/32x32",
      "age": 40,
      "eyeColor": "blue",
      "name": "Vega Ramsey",
      "gender": "male",
      "company": "SLAX",
      "email": "vegaramsey@slax.com",
      "phone": "+1 (922) 423-3501"
    },
    {
      "index": 5,
      "guid": "6573a90d-fb61-4faf-9856-853a0e980cb1",
      "isActive": true,
      "balance": "$3,010.03",
      "picture": "http://placehold.it/32x32",
      "age": 27,
      "eyeColor": "green",
      "name": "Jackson Baxter",
      "gender": "male",
      "company": "NITRACYR",
      "email": "jacksonbaxter@nitracyr.com",
      "phone": "+1 (833) 554-3814"
    }
  ];